import getCollectionQuery from "../../utils/getCollectionQuery";

export default function getWorksQuery(firebase, options) {
	if (!options) {
		return null;
	}

	const { publisher, imprint, serie, limit } = options;

	return getCollectionQuery(firebase.firestore().collection("works"), {
		fields: {
			publisher,
			imprint,
			serie,
		},
		limit,
		softDeletes: true,
	});
}
